/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ({

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

(function () {
    var Alignment = {
        hasSomeParentTheClass: function (element, classname) {
            try {
                if (element && element.className && element.className.split(' ').indexOf(classname) >= 0) {
                    return true;
                }

                return element.parentNode && Alignment.hasSomeParentTheClass(element.parentNode, classname);
            } catch (e) {
                return false;
            }
        },

        resize: function () {
            var offset = 0;
            var index = 0;
            var topRow = [];
            var allElements = {};

            var remainingElements = Array.prototype.slice.call(document.querySelectorAll('.align-height'))
            .filter(function (element) {
                return Object.prototype.toString.call(element) === '[object HTMLDivElement]';
            })
            .filter(function (element) {
                return !Alignment.hasSomeParentTheClass(element, 'columnmarker');
            });

            do {
                allElements = Alignment.splitByTopRow(remainingElements);
                topRow = allElements.topRow;
                remainingElements = allElements.remaining;
                Alignment.alignRow(topRow);
                Alignment.alignButtonInProductToBottom(topRow);
            } while (remainingElements.length > 0);
        },

        alignRow: function (row) {
            var maxHeight = 0;

            // Reset height
            row.forEach(function (element) {
                element.style.height = 'auto';
            });

            // Find the highest element
            row.forEach(function (element) {
                var height = $(element).outerHeight(true);
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

            // Set height
            row.forEach(function (element) {
                element.style.height = maxHeight + 'px';
            });
        },

        splitByTopRow: function (elementsArray) {
            // Shallow copy
            var elements = elementsArray.slice(0);

            var offset = Alignment.getOffset(elements[0]);

            var predicate = function (element) {
                return Alignment.getOffset(element) === offset;
            };

            var topRow = Alignment.takeWhile(elements, predicate);

            topRow.forEach(function (element) {
                elements.splice(elements.indexOf(element), 1);
            });

            return {
                topRow: topRow,
                remaining: elements
            };
        },

        getOffset: function (element) {
            var offset = $(element).offset();
            return offset && offset.top;
        },

        alignButtonInProductToBottom: function (row) {
            var productBoxesBtn = [];

            row.map(function (element) {
                Array.prototype.slice.call(element.querySelectorAll('.product-box-btn.js-align-bottom'))
                .filter(function (element) { return Object.prototype.toString.call(element) === '[object HTMLDivElement]' })
                .forEach(function (element) {
                    productBoxesBtn.push(element);
                });
            });

            var $productBoxes = $(productBoxesBtn).closest('.product-box');

            $productBoxes.each(function () {
                var $pushbox = $(this);
                var totalHeight = $pushbox.outerHeight();
                var btnHeight = $pushbox.find('.component-btn').outerHeight();
                var standingProductBox = $pushbox.height() > $pushbox.width();
                var margin = totalHeight - 105;
                var isMobile = window.matchMedia("only screen and (max-width: 1024px)");

                if (standingProductBox || (isMobile.matches && !standingProductBox)) {
                    margin = margin - 127;
                }

                $pushbox
                .find('.js-align-bottom')
                .css({
                   top: Math.max(0, margin)
               });
            });
        },

        // From http://sufflavus.github.io/JS-Tips-Take-While
        takeWhile: function (source, predicate) {
            var stopIndex = source.length;

            source.some(function (n, index) {
                return predicate(n, index) ? false : ((stopIndex = index), true);
            });

            return source.slice(0, stopIndex);
        }
    };

    var docWidth = $(document).width();

    $('.tab').click(Alignment.resize);
    $(window).load(Alignment.resize);
    $(window).resize(function () {
        var newWidth = $(document).width();

        if (docWidth !== newWidth) {
            Alignment.resize();
            docWidth = newWidth;
        }
    });
})();

/***/ })

/******/ });


// WEBPACK FOOTER //
// JS Logics/AlignHeight.min.js